import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import Header from 'components/ui/general/Header';
import PasswordForgottenForm from './PasswordForgottenForm';
import Notification from 'components/notifications/Notification';
import Title from 'components/ui/general/Title';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showNotification } from 'store/actions/uiActions';
import styled from 'styled-components';
import translate from 'components/hoc/translate';

const StyledBackground = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(/images/background_mobian.jpg) no-repeat center bottom fixed;
    background-size: cover;
    z-index: -1;
`;

const StyledCard = styled(Card)`
    width: 400px;
    max-width: 400px;
    padding: 1rem;
`;

class PasswordForgottenContainer extends Component {
    constructor() {
        super();

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(values) {
        const {
            history,
            showNotifications,
            translate,
        } = this.props;

        return apiClient.create(`${ config.getApiBaseUrl() }/auth/password-forgotten`, values).then(() => {
            showNotifications(translate('auth.forgotPassword.notifications.success'), 'success');
        }).then(() => {
            history.push('/login');
        });
    }

    render() {
        const { translate } = this.props;

        return (
            <div>
                <StyledBackground />

                <StyledCard>
                    <Header>
                        <Title
                            title={ translate('auth.forgotPassword.title') }
                        />
                    </Header>

                    <PasswordForgottenForm
                        form='password-forgotten'
                        handleSubmitForm={ this.handleSubmit }
                    />
                </StyledCard>

                <Notification />
            </div>
        );
    }
}

PasswordForgottenContainer.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    showNotifications: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        showNotifications: (text, type) => {
            dispatch(showNotification(text, type));
        },
    };
};

const enhance = compose(
    translate,
    connect(null, mapDispatchToProps),
);

export default enhance(PasswordForgottenContainer);


// WEBPACK FOOTER //
// ./src/pages/password-forgotten/PasswordForgottenContainer.js